const updates = [
  {
    time: '10分钟前',
    title: '《我独自升级》第179话更新',
    desc: '成肖宇面对最终Boss，觉醒全新能力，战斗进入白热化阶段。',
    type: '韩漫',
    dot: 'primary',
  },
  {
    time: '28分钟前',
    title: '《咒术回战》第261话更新',
    desc: '五条悟与宿傩的最终决战迎来转折，领域展开震撼全场。',
    type: '日漫',
    dot: 'accent',
  },
  {
    time: '1小时前',
    title: '《天官赐福》第117话更新',
    desc: '花城与谢怜重逢，八百年的等待终于迎来圆满。',
    type: '国漫',
    dot: 'secondary',
  },
  {
    time: '2小时前',
    title: '《某天成为公主》第132话更新',
    desc: '阿纳斯塔西娅在皇宫舞会上惊艳全场，克洛德的态度开始转变。',
    type: '韩漫',
    dot: 'primary',
  },
  {
    time: '3小时前',
    title: '《镖人》第108话更新',
    desc: '刀马一行人在大漠中遭遇沙暴，新的敌人悄然逼近。',
    type: '国漫',
    dot: 'secondary',
  },
  {
    time: '5小时前',
    title: '《海贼王》第1111话更新',
    desc: '路飞开启五档新形态，与五老星的战斗全面爆发。',
    type: '日漫',
    dot: 'accent',
  },
  {
    time: '6小时前',
    title: '《追踪者》第64话更新',
    desc: '主角发现关键线索，连环案件的真相逐渐浮出水面。',
    type: '韩漫',
    dot: 'primary',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">更新动态</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">实时追踪，不错过任何精彩章节</p>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300" />

          <div className="space-y-4">
            {updates.map((u, i) => (
              <div key={i} className="relative flex items-start gap-4 pl-10">
                <div className={`absolute left-[15px] top-1.5 w-2.5 h-2.5 rounded-full flex-shrink-0 ${
                  u.dot === 'primary' ? 'bg-primary-500' :
                  u.dot === 'accent' ? 'bg-accent-500' : 'bg-secondary-500'
                }`} />

                <div className="flex-1 min-w-0 bg-background-50 rounded-lg border border-background-200/70 p-4">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-xs text-foreground-400">{u.time}</span>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium ${
                      u.dot === 'primary' ? 'bg-primary-50 text-primary-600' :
                      u.dot === 'accent' ? 'bg-accent-50 text-accent-600' : 'bg-secondary-50 text-secondary-600'
                    }`}>{u.type}</span>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-800">{u.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1 leading-relaxed">{u.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}